
import React, { useEffect, useState } from 'react';
import ODALogo from'../../assets/logos/logoblanco.svg'

import { AiOutlineMenu } from "react-icons/ai";
import { AiOutlineClose } from "react-icons/ai";

import './index.css'

const Header = () => {
    const [showResponsiveMenu, setShowResponsiveMenu] = useState(false)
    const [hanburgerMenuClass, setHamburgerMenuClass] = useState('')

    useEffect(() => {
        setHamburgerMenuClass(showResponsiveMenu ? 'open-hambuger-menu' : '')
    }, [showResponsiveMenu]);

    return (
        <header className={`header-wrapper`}>
            <div className={`header-items-wrapper ${hanburgerMenuClass}`}>
                <>
                    <a href="https://www.odamexico.org">
                        <img className="header-logo image" src={ODALogo} alt="(Home Icon) Otros Dreams en Acción" height="75" />
                    </a>
                    <div className='header-hamburger-btn'>
                        { showResponsiveMenu ?
                            <AiOutlineClose focusable color='#fff' size={28} title='close navigation menu' onClick={() => setShowResponsiveMenu(false)} /> :
                            <AiOutlineMenu focusable color='#fff' size={28} title='open navigation menu' onClick={() => setShowResponsiveMenu(true)}/>
                        }
                    </div>

                </>
                <div className={`header-links-wrapper ${hanburgerMenuClass}`}>
                    <a href="https://www.odamexico.org" className="header-link-item">HOME</a>
                    <a href="http://lxsotrxsdreamers.odamexico.org" className="header-link-item">LXS OTROS DREAMERS</a>
                    <a href="https://www.odamexico.org/tarjeta-verde" className="header-link-item">TARJETA VERDE</a>
                    <a href="https://donate.odamexico.org" className="header-link-item">DONATE!</a>
                </div>
            </div>
        </header>
    );
}

export default Header;